import "./svg/qr-code.svg"

export default {
    name: "qr-code",
    viewBox: "24 24",
}
